import { Typography, Button, Box, Grid, Container } from '@mui/material';
import React, { useEffect, useState, useRef } from 'react';
import Contactform from './Contactform';
import { HashLink } from 'react-router-hash-link';
import ResponsiveAppBarAlt from './ResponsiveAppBarAlt';
import Footer from "./Footer";
import '../App.css';

const ScrollAnimation = () => {
    const [isVisible1, setIsVisible1] = useState(false);
    const [isVisible2, setIsVisible2] = useState(false);
    const [isVisible3, setIsVisible3] = useState(false);
    const [isVisible4, setIsVisible4] = useState(false);
    const [isVisible5, setIsVisible5] = useState(false);
    const [isVisible6, setIsVisible6] = useState(false);
    const [isVisible7, setIsVisible7] = useState(false);
    const [isVisible8, setIsVisible8] = useState(false);
    const [isHeroNavVisible, setIsHeroNavVisible] = useState(true);

    const animatedBoxRef1 = useRef(null);
    const animatedBoxRef2 = useRef(null);
    const animatedBoxRef3 = useRef(null);
    const animatedBoxRef4 = useRef(null);
    const animatedBoxRef5 = useRef(null);
    const animatedBoxRef6 = useRef(null);
    const animatedBoxRef7 = useRef(null);
    const animatedBoxRef8 = useRef(null);
    const heroNavWrapperRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            const screenHeight = window.innerHeight;

            if (animatedBoxRef1.current) {
                const boxPosition1 = animatedBoxRef1.current.getBoundingClientRect().top;
                if (boxPosition1 < screenHeight * 0.8) {
                    setIsVisible1(true);
                }
            }

            if (animatedBoxRef2.current) {
                const boxPosition2 = animatedBoxRef2.current.getBoundingClientRect().top;
                if (boxPosition2 < screenHeight * 0.8) {
                    setIsVisible2(true);
                }
            }

            if (animatedBoxRef3.current) {
                const boxPosition3 = animatedBoxRef3.current.getBoundingClientRect().top;
                if (boxPosition3 < screenHeight * 0.8) {
                    setIsVisible3(true);
                }
            }

            if (animatedBoxRef4.current) {
                const boxPosition4 = animatedBoxRef4.current.getBoundingClientRect().top;
                if (boxPosition4 < screenHeight * 0.8) {
                    setIsVisible4(true);
                }
            }
            if (animatedBoxRef5.current) {
                const boxPosition5 = animatedBoxRef5.current.getBoundingClientRect().top;
                if (boxPosition5 < screenHeight * 0.8) {
                    setIsVisible5(true);
                }
            }
            if (animatedBoxRef6.current) {
                const boxPosition6 = animatedBoxRef6.current.getBoundingClientRect().top;
                if (boxPosition6 < screenHeight * 0.8) {
                    setIsVisible6(true);
                }
            }

            if (animatedBoxRef7.current) {
                const boxPosition7 = animatedBoxRef7.current.getBoundingClientRect().top;
                if (boxPosition7 < screenHeight * 0.8) {
                    setIsVisible7(true);
                }
            }
            if (animatedBoxRef8.current) {
                const boxPosition8 = animatedBoxRef8.current.getBoundingClientRect().top;
                if (boxPosition8 < screenHeight * 0.8) {
                    setIsVisible8(true);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsHeroNavVisible(entry.isIntersecting);
                const navbar = document.querySelector(".navbar.alt");
                if (navbar) {
                    if (!entry.isIntersecting) {
                        navbar.style.marginTop = "0px";
                    } else {
                        navbar.style.marginTop = "-100px";
                    }
                }
            },
            { threshold: 0.01 }
        );

        if (heroNavWrapperRef.current) {
            observer.observe(heroNavWrapperRef.current);
        }

        return () => {
            if (heroNavWrapperRef.current) {
                observer.unobserve(heroNavWrapperRef.current);
            }
        };
    }, []);

    // Visibility Notarinfo
    const [isVisibleN1, setIsVisibleN1] = useState(false);
    const [isVisibleN2, setIsVisibleN2] = useState(false);

    const toggleVisibility = (elementId) => {
        if (elementId === 'elementToToggle1') {
            setIsVisibleN1(!isVisibleN1);
        } else if (elementId === 'elementToToggle2') {
            setIsVisibleN2(!isVisibleN2);
        }
    };

    return (
        <Box className="containerMain">

            <ResponsiveAppBarAlt />

            <div className="App">
                <main>
                    <div>
                        <Box className="heroWrapper" id="start">
                            <img src="Michaelsberg-Siegburg.webp" className='herobackimg' />
                            <Box className='heroWrapperLayer'></Box>
                            <Container maxWidth="lg" className="containerHero" /*sx={{width: 300,backgroundColor: 'success.main',}}*/>
                                <Box className="HeroBox">
                                    <img src='HT-Logo.png' className='HeroLogoImg' />
                                    <Typography variant='h1' align='center' color="textPrimary" gutterBottom>
                                        Harbecke & Thelen <br />
                                        Notare
                                    </Typography>
                                </Box>

                            </Container>

                            <Box className="heroNavWrapper" ref={heroNavWrapperRef}>
                                <HashLink className='navItemHero' smooth to="#leistungen">Leistungen</HashLink>
                                <HashLink className='navItemHero' smooth to="#notare">Notare</HashLink>
                                <HashLink className='navItemHero' smooth to="/Team">Team</HashLink>
                                <HashLink className='navItemHero' smooth to="#kontakt">Kontakt</HashLink>
                                <HashLink className='navItemHero flex' smooth to="/en"><img src="en-flag.png" className='navFlagIcon' />EN</HashLink>
                            </Box>
                            {/* 
                            <div className="heroCTAWrapper">
                                <Button href="#" target='_blank' variant='contained' className='mandantenCTATop'>Mandanten Login<img src='arrow-weiss.png' className='servOptItemArrow' /></Button>
                            </div> */}
                        </Box>



                        <Box className="mainWrapper">

                            <Box className="section" id="subhero">
                                <Container maxWidth="lg" className="container">
                                    <Box className="textBox">
                                        <Grid container justifyContent="center" spacing={2}>
                                            <Grid container item xs={12} sm={12} spacing={0} className='textIntendOuterFlexbox'>
                                                <Box className="intendTextWrapper">
                                                    <Typography variant='h2' className='subtitleH3'>Wir heißen Sie herzlich willkommen in unserem Notarbüro!</Typography>
                                                    <Box className="textintendInnerWrapper">
                                                        <Typography variant='body1'>Ganz gleich, ob sie eine Immobilie kaufen, ein Testament errichten oder ein Unternehmen gründen wollen – wir stehen Ihnen bei allen bedeutenden Lebensentscheidungen als rechtliche Berater zur Seite. Unser Ziel ist, auf höchstem fachlichen Niveau pragmatische Lösungen für Sie zu entwickeln. Wir sind insbesondere für die Gemeinden Siegburg, Troisdorf, Much, Neunkirchen-Seelscheid, Niederkassel und Sankt Augustin zuständig.</Typography>
                                                        <Typography variant='body1'><span className="roterAkzent">Achtung:</span> Ab dem 23.02.2026 befinden sich unsere Büroräume im Geschäftshaus Am Brauhof 2, 53721 Siegburg.</Typography>
                                                        <Box className="notarOfficeImgWrapper">
                                                            <img src='Thelen-und-Harbecke-gemeinsam.webp' className='notarImg' />
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Box className="intendTextWrapper">
                                                    <Typography variant='h2' className='subtitleH3'>Übermitteln Sie uns ihr Anliegen gerne auch online</Typography>
                                                    <Box className="textintendInnerWrapper">
                                                        <Typography variant='body1'>Sie können uns gern jederzeit unter unserer E-Mail-Adresse <a href="mailto:info@ht-notare.de">info@ht-notare.de</a> kontaktieren. Alternativ können Sie uns über unser Kontaktformular unkompliziert zu jeder Tages- und Nachtzeit Ihr individuelles Anliegen schildern. Wir werden uns schnellstmöglich bei Ihnen melden.</Typography>
                                                        <div className="ctaWrapper fadeInOpac">
                                                            <HashLink className='btnSecondary' smooth to="#kontakt">Zum Formular</HashLink>
                                                        </div>
                                                    </Box>
                                                </Box>
                                            </Grid>

                                        </Grid>
                                    </Box>
                                </Container>
                            </Box>


                            <Box className="section leistungen" id="info">
                                <Container maxWidth="lg" className="container" id="leistungen">
                                    <Box className="intendTextWrapper textBox">
                                        <Typography variant='h2' className='subtitleH3 whiteText'>Unsere Leistungen</Typography>
                                        <Box className="textintendInnerWrapper">
                                            <Typography variant='body1' className='whiteText'>Insbesondere zu den nachfolgenden Themen stehen wir Ihnen als unabhängige und neutrale Berater zur Verfügung. Damit wir Ihren Fall so schnell wie möglich bearbeiten können, klicken Sie bitte auf das passende Themenfeld. Sie erhalten dann grundlegende Informationen zu Ihrem Vorgang. Bitte füllen Sie das jeweilige angezeigte Formular online aus. Auf diese Weise stellen wir sicher, dass wir alle relevanten Informationen haben und damit ihren Vorgang schnellstmöglich bearbeiten können.</Typography>
                                        </Box>
                                    </Box>

                                    <Box className="leistungenGrid">

                                        <Box className={`servOptItem ${isVisible1 ? 'visible one' : ''}`} ref={animatedBoxRef1}>
                                            <HashLink className='servOptItemLink' smooth to="/immobilien-kaufen-und-verkaufen#">
                                                <Box className="servOptItemImgWrapper">
                                                    <img src='Immobilien-Leistung.webp' className='servOptItemImg' />
                                                </Box>
                                                <Box className="servOptItemTextWrapper">
                                                    <Typography variant='body1'>Immobilie kaufen oder verkaufen</Typography>
                                                    <img src='arrow-weiss.png' className='servOptItemArrow' />
                                                </Box>
                                            </HashLink>
                                        </Box>

                                        <Box className={`servOptItem ${isVisible2 ? 'visible two' : ''}`} ref={animatedBoxRef2}>
                                            <HashLink className='servOptItemLink' smooth to="/immobilienschenken#">
                                                <Box className="servOptItemImgWrapper">
                                                    <img src='immobilie.webp' className='servOptItemImg' />
                                                </Box>
                                                <Box className="servOptItemTextWrapper">
                                                    <Typography variant='body1'>Immobilie schenken</Typography>
                                                    <img src='arrow-weiss.png' className='servOptItemArrow' />
                                                </Box>
                                            </HashLink>
                                        </Box>

                                        <Box className={`servOptItem ${isVisible3 ? 'visible three' : ''}`} ref={animatedBoxRef3}>
                                            <HashLink className='servOptItemLink' smooth to="/erbenundvererben#">
                                                <Box className="servOptItemImgWrapper">
                                                    <img src='serviceErbe1.webp' className='servOptItemImg' />
                                                </Box>
                                                <Box className="servOptItemTextWrapper">
                                                    <Typography variant='body1'>Erben und Vererben</Typography>
                                                    <img src='arrow-weiss.png' className='servOptItemArrow' />
                                                </Box>
                                            </HashLink>
                                        </Box>

                                        <Box className={`servOptItem ${isVisible4 ? 'visible one' : ''}`} ref={animatedBoxRef4}>
                                            <HashLink className='servOptItemLink' smooth to="/vorsorgetreffen#">
                                                <Box className="servOptItemImgWrapper">
                                                    <img src='serviceFami1.webp' className='servOptItemImg' />
                                                </Box>
                                                <Box className="servOptItemTextWrapper">
                                                    <Typography variant='body1'>Vorsorge treffen</Typography>
                                                    <img src='arrow-weiss.png' className='servOptItemArrow' />
                                                </Box>
                                            </HashLink>
                                        </Box>

                                        <Box className={`servOptItem ${isVisible5 ? 'visible two' : ''}`} ref={animatedBoxRef5}>
                                            <HashLink className='servOptItemLink' smooth to="/familie#">
                                                <Box className="servOptItemImgWrapper">
                                                    <img src='Familie-Leistung.webp' className='servOptItemImg' />
                                                </Box>
                                                <Box className="servOptItemTextWrapper">
                                                    <Typography variant='body1'>Familie</Typography>
                                                    <img src='arrow-weiss.png' className='servOptItemArrow' />
                                                </Box>
                                            </HashLink>
                                        </Box>

                                        <Box className={`servOptItem ${isVisible6 ? 'visible three' : ''}`} ref={animatedBoxRef6}>
                                            <HashLink className='servOptItemLink' smooth to="/unternehmen#">
                                                <Box className="servOptItemImgWrapper">
                                                    <img src='Unternehmen-Leistung.webp' className='servOptItemImg' />
                                                </Box>
                                                <Box className="servOptItemTextWrapper">
                                                    <Typography variant='body1'>Unternehmen</Typography>
                                                    <img src='arrow-weiss.png' className='servOptItemArrow' />
                                                </Box>
                                            </HashLink>
                                        </Box>

                                        <Box className={`servOptItem ${isVisible7 ? 'visible one' : ''}`} ref={animatedBoxRef7}>
                                            <HashLink className='servOptItemLink' smooth to="/vereine#">
                                                <Box className="servOptItemImgWrapper">
                                                    <img src='Verein-Leistung.webp' className='servOptItemImg' />
                                                </Box>
                                                <Box className="servOptItemTextWrapper">
                                                    <Typography variant='body1'>Vereine</Typography>
                                                    <img src='arrow-weiss.png' className='servOptItemArrow' />
                                                </Box>
                                            </HashLink>
                                        </Box>

                                        <Box className={`servOptItem ${isVisible8 ? 'visible two' : ''}`} ref={animatedBoxRef8}>
                                            <HashLink className='servOptItemLink' smooth to="/beglaubigung#">
                                                <Box className="servOptItemImgWrapper">
                                                    <img src='Beglaubigung.webp' className='servOptItemImg' />
                                                </Box>
                                                <Box className="servOptItemTextWrapper">
                                                    <Typography variant='body1'>Beglaubigung</Typography>
                                                    <img src='arrow-weiss.png' className='servOptItemArrow' />
                                                </Box>
                                            </HashLink>
                                        </Box>

                                    </Box>

                                </Container>
                            </Box>

                            <Box className="section" id="notare">
                                <Container maxWidth="lg" className="container section" id="notare">
                                    <Typography variant='h2' className='sectionTitle'>
                                        Ihre Notare
                                    </Typography>


                                    <Grid item xs={12} sm={12} className='notarElement'>
                                        <Box className="notarElementGrid">
                                            <Box className="notarImgWrapper">
                                                <img src='Harbecke-Profil.webp' className='notarImg' />
                                            </Box>
                                            <Box className="notarInnerBox">
                                                <Box>
                                                    <Typography variant='h3' className='subtitleH3'>Notarin Dr. Antonia Harbecke MJur (Oxford)</Typography>
                                                    <Typography variant='h4' className='subtitleH4'>Amtsnachfolgerin des Notars Dr. Jens Watzek</Typography>
                                                </Box>
                                                <Box id="elementToToggle1" className={`notarBodyTextWrapper ${isVisibleN1 ? 'visible' : ''}`}>
                                                    <Typography variant='body1' paragraph className='notarBodyText'>
                                                        Geboren und aufgewachsen bin ich in Niedersachen. Das Studium der deutschen Rechtswissenschaften in Göttingen schloss ich als Landesbeste ab. Sodann absolvierte ich ein Auslandsstudium an der Universität Oxford, durch das ich den zusätzlichen Titel Magister Juris erwarb. Nach dem Rechtsreferendariat in Berlin war ich dort als Anwältin in einer großen deutschen Wirtschaftskanzlei in den Bereichen Gesellschaftsrecht und Immobilienwirtschaftsrecht tätig. Außerdem arbeitete ich als Anwältin in London. Nach der Übernahme in den Anwärterdienst der Rheinischen Notarkammer war ich als Notarassessorin insbesondere in Bergisch Gladbach und Köln tätig. Ich bin verheiratet und habe eine Tochter. <br /><br />
                                                        Ich beurkunde in deutscher und englischer Sprache.<br /><br />
                                                        Seit dem 1. September 2024 bin ich Notarin in Sieburg. Ich verwahre die Urkunden der ehemaligen Notare Dr. Frowin Dieck und Dr. Jens Watzek sowie der Notariatsverwalterin Anne Warflinger.</Typography>
                                                </Box>
                                                <Button className='btnSecondary' onClick={() => toggleVisibility('elementToToggle1')}>{`${isVisibleN1 ? 'Einklappen' : 'Mehr erfahren'}`}</Button>
                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={12} className='notarElement'>
                                        <Box className="notarElementGrid">
                                            <Box className="notarImgWrapper">
                                                <img src='Thelen-Profil.webp' className='notarImg' />
                                            </Box>
                                            <Box className="notarInnerBox">
                                                <Box>
                                                    <Typography variant='h3' className='subtitleH3'>Notar Dr. Martin Konstantin Thelen, LLM (Columbia)</Typography>
                                                    <Typography variant='h4' className='subtitleH4'>Amtsnachfolger des Notars Dr. Christian Sickinger</Typography>
                                                </Box>
                                                <Box id="elementToToggle2" className={`notarBodyTextWrapper ${isVisibleN2 ? 'visible' : ''}`}>
                                                    <Typography variant='body1' paragraph className='notarBodyText'>
                                                        Aufgewachsen bin ich an der Siegmündung in Troisdorf-Bergheim als einer der vielen Nachfahren der Fischerei-Familie Engels und der Mondorfer Schiffsbauer-Familie Bröhl. Nach der Schulzeit und dem Studium der deutschen Rechtswissenschaften in Bonn absolvierte ich ein Auslandsstudium in New York City, durch das ich zusätzlich den Titel Master of Laws (LLM) führen darf. Mein Rechtsreferendariat leistete ich u.a. bei der Europäischen Zentralbank in Frankfurt a.M. und einer internationalen Rechtsanwaltskanzlei in Singapur ab. Die Sehnsucht nach dem Rheinland blieb aber immer bestehen. Deswegen wechselte ich rasch nach Abschluss meiner juristischen Ausbildung in den Anwärterdienst der Rheinischen Notarkammer. Als Notarassessor war ich in Bergisch Gladbach und zwei Jahre beim Deutschen Notarinstitut in Würzburg tätig.<br /><br />

                                                        Nebenamtlich engagiere ich mich in der Ausbildung des juristischen Nachwuchses als Leiter von Arbeitsgemeinschaften für Rechtsreferendare in Köln und als Referent am Deutschen Anwaltsinstitut (DAI). In zahlreichen wissenschaftlichen Veröffentlichungen widme ich mich u.a. schwierigen immobilien- und erbrechtlichen Fragestellungen wie unübersichtlichen Erbengemeinschaften, der Testamentsvollstreckung und dem digitalen Nachlass.<br /><br />

                                                        Ich beurkunde in deutscher und englischer Sprache.<br /><br />

                                                        Seit dem 1. April 2025 bin ich Notar in Siegburg. Ich verwahre die Urkunden des Notariatsverwalters André-Fabian Gerold und der ehemaligen Notare Dr. Kurt Reis und Dr. Christian Sickinger.</Typography>
                                                    <a href="Thelen_Veröffentlichungen.pdf" target="_blank" className='notarLink'>Meine Veröffentlichungen</a>
                                                </Box>
                                                <Button className='btnSecondary' onClick={() => toggleVisibility('elementToToggle2')}>{`${isVisibleN2 ? 'Einklappen' : 'Mehr erfahren'}`}</Button>
                                            </Box>
                                        </Box>
                                    </Grid>




                                    <Typography variant='body1' paragraph>Mehr Informationen zu unserem Team finden Sie <HashLink smooth to="/Team">hier</HashLink>.</Typography>
                                </Container>
                            </Box>

                            <Box className="map" id="map">
                                <Box className="contactMap">

                                    {/* <iframe width="100%" height="100%" frameBorder="0" allowFullScreen allow="geolocation" src="//umap.openstreetmap.de/en/map/notare-harbecke-thelen_85729?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=true&searchControl=false&tilelayersControl=null&embedControl=false&datalayersControl=null&onLoadPanel=none&captionBar=false&captionMenus=false&captionControl=null&locateControl=null&measureControl=null"></iframe> */}

                                    <a href="https://maps.app.goo.gl/BiTJESJc6NsTJLce6" target="_blank" class="contactMapLink">
                                        <img src="Karte-HT.webp" className="contactMapImg" />
                                        <a href="http://openstreetmap.org/copyright" target="_blank" className="mapSource">©OpenStreetMap</a>
                                    </a>
                                    <Container maxWidth="lg" className="container">
                                        <Typography variant='body1' paragraph className="contactMapAddress">
                                            Wenn Sie auf den Link klicken, verlassen Sie unsere Webseite und werden auf Google Maps (ein Service der Google Ireland Limited Gordon House, Barrow Street Dublin 4, Irland) weitergeleitet. Weitere Informationen zu Zweck und Umfang der Datenerhebung und ihrer Verarbeitung erhalten Sie in den Datenschutzerklärungen von <a href="http://www.google.de/intl/de/policies/privacy" target="_blank">Google</a>.
                                        </Typography>
                                    </Container>
                                    
                                </Box>
                                {/* <Container maxWidth="lg" id="routelink">
                                    <Typography variant='body1' paragraph className="contactMapRouteLink">Einen Routenplaner finden sie <a href="https://maps.app.goo.gl/BiTJESJc6NsTJLce6" target="_blank">hier</a>.</Typography>
                                </Container> */}

                            </Box>

                            <Box className="section bannergrey" id="kontakt">
                                <Container maxWidth="lg" className="container" id="kontakt">
                                    <Box className="kontaktGrid">
                                        <Box className="kontaktLeftSide smaller">
                                            <Typography variant='h2' className='sectionTitle white small'>
                                                Sie haben Fragen?  <br />
                                                Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Öffnungszeiten</b><br />
                                                Montag bis Freitag von 8:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                                                Mittwoch ab 13:00 Uhr geschlossen<br />
                                                Spätere Termine sind nach Vereinbarung möglich<br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Telefon</b><br />
                                                Sie erreichen uns unter: 02241 66444<br />
                                                Montag bis Freitag von 9:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                                                Mittwoch nur bis 13:00 Uhr. <br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>E-mail: info@ht-notare.de</b><br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Fax: 02241 55161</b><br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Anfahrt und Parkmöglichkeiten</b><br />
                                                Das Büro befindet sich im Zentrum von Siegburg im Geschäftshaus Am Brauhof 2. Die Kanzleiräume liegen in der ersten Etage und sind mittels eines Aufzugs und Treppenlifts barrierefrei zugängig. In der Tiefgarage Holzgasse können Sie die markierten Stellplätze 17a, 20, 27 und 29 kostenfrei nutzen. Diese erreichen Sie, indem Sie nach der Einfahrt in die Garage rechts abbiegen und dann bis zum Ende der Garage durchfahren. Hierbei passieren Sie eine rot leuchtende Ampel. Von den Stellplätzen aus gelangen Sie in das Treppenhaus und zum Lift. Weitere (kostenpflichtige) Parkmöglichkeiten befinden sich im Parkhaus von Galeria Kaufhof und Saturn, etwa 100 Meter entfernt liegend vom Büro.
                                            </Typography>
                                        </Box>
                                        <Contactform />
                                    </Box>
                                </Container>
                            </Box>

                        </Box>



                    </div>
                </main >
                <Footer />
            </div >

        </Box >
    );
};

export default ScrollAnimation;